import type { MultiSelectOption } from "../../ui";

export const MAX_ALERT_CHANNELS_PER_EVENT = 2;

export function alertChannelOptionsForSelection(
  options: MultiSelectOption[],
  selected: string[],
): MultiSelectOption[] {
  if (selected.length < MAX_ALERT_CHANNELS_PER_EVENT) {
    return options;
  }
  const selectedValues = new Set(selected);
  return options.map((option) => ({
    ...option,
    disabled: !selectedValues.has(option.value),
  }));
}
